import { DateWorker, dateWorker } from '@core/utils/date-worker';

export const getDiff = (value: DateWorker): number =>
  value.startOf('day').diff(dateWorker().startOf('day').format(), 'day');
